import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        occurrence: '=',
        context: '='
    },
    template: `
        <div class="heading01 type01">
            <h3>{{ 'user.Associated employees' | translate }}</h3>
            <a class="btn add" ng-if="vm.canManageOccurrences" ng-click="vm.addEmployee()">{{ 'user.Add more employees' | translate }}</a>
        </div>
        <div class="alert alert-danger" ng-if="vm.error">{{ vm.error }}</div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="loader02" ng-if="vm.loading">
            <p>{{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}</p>
        </div>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th>
                            <input
                                ng-disabled="!vm.canManageOccurrences"
                                ng-model="vm.checked"
                                ng-click="vm.toggleAll()"
                                type="checkbox"
                            />
                        </th>
                        <th>{{ 'planning.Name' | translate }}</th>
                        <th>{{ 'planning.Position' | translate }}</th>
                        <th>{{ 'planning.Previous date completed' | translate }}</th>
                        <th>{{ 'planning.Personal deadline' | translate }}</th>
                        <th>{{ 'planning.Status' | translate }}</th>
                        <th ng-if="vm.occurrence.isLimitAccessEnabled">{{ 'planning.Access until' | translate }}</th>
                        <th> </th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items" ng-class="{ status04: item.isInActive }">
                        <td>
                            <input
                                ng-disabled="!vm.canManageOccurrences"
                                type="checkbox"
                                ng-checked="vm.hasEmployeeId(item.userId)"
                                ng-click="$event.stopPropagation();vm.toggleEmployeeId(item.userId)"
                            />
                        </td>
                        <td>
                            {{ item.displayName }}
                            <small ng-if="item.isInActive"> ({{ 'user.Inactive' | translate }})</small>
                            <span ng-if="item.hasOptionalTarget" class="badge"> {{ 'occurrence.Optional target' | translate }} </span>
                        </td>
                        <td>
                            <drl-partial-table drls="item.drls"></drl-partial-table>
                        </td>
                        <td>{{ item.previousPassedTime ? vm.MomentService.formatDate(item.previousPassedTime.date) : '-' }}</td>
                        <td ng-bind-html="item.personalDeadline | personalDeadline: item.previousPassedTime:vm.isInfiniteDeadline"></td>
                        <td>{{ vm.getCourseStatusText(item.courseProgressStatus) }}</td>
                        <td ng-if="vm.occurrence.isLimitAccessEnabled">{{ item.accessUntil? vm.MomentService.formatTimeStamp(item.accessUntil) : '-' }}</td>
                        <td>
                            <a class="btn delete" ng-click="vm.remove(item.userId)">{{ 'general.Remove' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
        <div class="form" ng-if="vm.checkedUserIds.length > 0">
            <div class="row inline">
                <label class="label bulkactions">{{ 'planning.employee.Bulk actions' | translate }}</label>
                <div class="items">
                    <option></option>
                    <select class="form-control small" ng-model="vm.bulkAction">
                        <option value="{{ vm.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM.KEYS.REMOVE_SELECTED }}">
                            {{ vm.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM.LABELS.REMOVE_SELECTED }}
                        </option>
                        <option value="{{ vm.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM.KEYS.CHANGE_ACCESS_UNTIL }}" ng-if="vm.occurrence.isLimitAccessEnabled">
                            {{ vm.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM.LABELS.CHANGE_ACCESS_UNTIL }}
                        </option>
                    </select>
                    <button ng-if="vm.bulkAction"
                            class="btn bordered02"
                            ng-click="vm.doBulkAction()"
                    >
                        {{ 'general.Ok' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <ul class="actions01">
            <li class="primary" ng-if="vm.canManageOccurrences">
                <a ng-click="vm.next()" ng-if="!vm.checkedUserIds.length" class="btn main">
                    <span>{{ 'general.Next' | translate }}</span>
                </a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.list()" class="btn discrete" >
                    <span >{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($q, $state, $translate, lodash, DATATABLES, ListFactory, OccurrenceResource, UserResource,
                 ModalService, PrivilegeService, OccurrenceService, MomentService, USER_STATUS_ENUM, PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM,
                 COURSE_PROGRESS_STATUS_TYPE_ENUM, moment) {
        this.$q = $q;
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.OccurrenceResource = OccurrenceResource;
        this.UserResource = UserResource;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.OccurrenceService = OccurrenceService;
        this.MomentService = MomentService;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.loading = false;
        this.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM = PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM;
        this.moment = moment;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;

        this.newAccessUntilTime = null;
        this.bulkAction = null;
    }

    $onInit () {
        this.isInfiniteDeadline = this.course.expirationMonths === null;
        this.canManageOccurrences = this.PrivilegeService.canManageOccurrences()
            && !this.OccurrenceService.isCancelled(this.occurrence);

        this.list = this.ListFactory.createWithPagination(
            this.OccurrenceResource.getParticipants.bind(this.OccurrenceResource)
        );
        this.list.pagination.perPage = 25;
        this.allIds = [];
        this.fetch();
    }

    fetch () {
        this.$q.all({
            paginatedList: this.list.fetch({}, { occurrenceId: this.occurrence.id, privilegesCheck: 0 }),
            list: this.OccurrenceResource.getParticipants(
                {
                    pageSize: 0,
                    fields: 'userId,displayName,hasSubmittedFeedback',
                    privilegesCheck: 0
                },
                { occurrenceId: this.occurrence.id }
            ).$promise,
            occurrenceParticipants: this.OccurrenceResource.getParticipants({}, { occurrenceId: this.occurrence.id })
        }).then(response => {
            this.checkedUserIds = [];
            this.occurrence.courseOccurrenceParticipants = response.occurrenceParticipants;
            this.allParticipants = response.list;
            this.allIds = response.list.map(participant => participant.userId);
            this.trainingTimeRelatedParticipants = response.paginatedList.filter(participant => participant.isTrainingTimeRelated === true);
            this.checked = false;
            this.error = false;

            this.collectedPoints = [];
            if (this.PrivilegeService.canManageLicencePoints()) {
                this.UserResource.licencePoints({
                    'userIds[]': this.allIds,
                    occurrenceId: this.occurrence.id
                }).$promise.then(points => {
                    this.collectedPoints = points;
                });
            }
        });
    }

    getCourseStatusText (courseProgressStatus) {
        if (courseProgressStatus !== '' &&
            Object.prototype.hasOwnProperty.call(
                this.COURSE_PROGRESS_STATUS_TYPE_ENUM.LABELS,
                courseProgressStatus
            )
        ) {
            return this.COURSE_PROGRESS_STATUS_TYPE_ENUM.LABELS[courseProgressStatus];
        }

        return '-';
    }

    toggleAll () {
        this.checkedUserIds = this.checked ? this.list.items.map(item => item.userId) : [];
    }

    hasEmployeeId (id) {
        return this.lodash.includes(this.checkedUserIds, id);
    }

    toggleEmployeeId (id) {
        if (this.hasEmployeeId(id)) {
            this.lodash.pull(this.checkedUserIds, id);
            this.checked = false;
        }
        else {
            this.checkedUserIds.push(id);
        }
    }

    addEmployee () {
        const { occurrence } = this;
        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-occurrence-employee
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    occurrence="vm.occurrence"
                />`,
            controller ($uibModalInstance) {
                this.occurrence = occurrence;
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => this.fetch());
    }

    getKeepIds () {
        return this.allIds.filter(id => !this.lodash.includes(this.checkedUserIds, id));
    }

    openChangeAccessUntilTimeModal (accessUntil) {
        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-planning-change-access-until
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    access-until="vm.accessUntil"
                />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.accessUntil = accessUntil;
            }
        });
    }

    remove (id = null) {
        if (id) {
            this.checkedUserIds = [id];
        }

        const relations = {
            trainingTimeParticipants: this.trainingTimeRelatedParticipants.filter(
                participant => this.lodash.includes(this.checkedUserIds, participant.userId)
            ),
            versionLicences: this.collectedPoints.filter(
                point => this.lodash.includes(this.checkedUserIds, point.userId)
            ),
            feedbackSubmittedParticipants: (this.allParticipants || []).filter(
                participant => participant.hasSubmittedFeedback
                    && this.lodash.includes(this.checkedUserIds, participant.userId)
            )
        };

        let message = this.$translate.instant('planning.employees_default_remove_message');
        if (relations.feedbackSubmittedParticipants.length) {
            message = this.$translate.instant('planning.employees_feedback_submitted_remove_message', {
                user_names: relations.feedbackSubmittedParticipants
                    .map(participant => participant.displayName)
                    .join(', ')
            });
        }
        else if (relations.trainingTimeParticipants.length && relations.versionLicences.length) {
            message = this.$translate.instant('planning.employees_training_time_related_remove_message_with_points');
        }
        else if (relations.trainingTimeParticipants.length) {
            message = this.$translate.instant('planning.employees_training_time_related_remove_message');
        }
        else if (relations.versionLicences.length) {
            message = this.$translate.instant('planning.employees_collected_licence_points_remove_message');
        }

        this.ModalService.confirm(message, 'medium').then(() => {
            this.saving = true;
            this.loading = true;
            this.OccurrenceResource
                .removeParticipants({ id: this.occurrence.id }, { ids: this.checkedUserIds })
                .$promise.then(() => {
                    this.fetch();
                })
                .catch((error) => {
                    this.error = this.lodash.get(error.data, '[0].message');
                }).finally(() => {
                    this.saving = false;
                    this.loading = false;
                    this.checkedUserIds = [];
                });
        });
    }

    next () {
        this.UserResource.plannedUsers({
            courseId: this.occurrence.courseId,
            excludeOccurrenceId: this.occurrence.id,
            pageSize: 0
        })
        .$promise
        .then(users => {
            if (users.length) {
                const plannedUsers = users.map(user => user.displayName).join(', ');
                const message = this.$translate.instant('planning.planned_users_message', {
                    planned_users: plannedUsers
                });
                this.ModalService.confirm(message, 'medium').then(() => this.goNext());
            }
            else {
                const keepIds = this.getKeepIds();
                this.UserResource.query({
                    status: this.USER_STATUS_ENUM.KEYS.INACTIVE,
                    pageSize: 0
                }).$promise.then(employees => {
                    const inActiveEmployees = employees.filter(employee => this.lodash.includes(keepIds, employee.id));
                    if (inActiveEmployees.length) {
                        this.error = this.$translate.instant('planning.Some employees are inactive', {
                            inactive_employees: inActiveEmployees.map(employee => employee.displayName).join(', ')
                        });
                    }
                    if (!this.error) {
                        if (this.occurrence.capacity && keepIds.length > this.occurrence.capacity) {
                            const message = this.$translate.instant('planning.capacity_over_message', {
                                added_employee_count: keepIds.length,
                                capacity: this.occurrence.capacity
                            });
                            this.ModalService.confirm(message, 'medium').then(() => this.goNext());
                        }
                        else {
                            this.goNext();
                        }
                    }
                });
            }
        });
    }

    doBulkAction () {
        if (this.bulkAction === this.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM.KEYS.REMOVE_SELECTED) {
            this.remove();
        }

        if (this.bulkAction === this.PLANNING_EMPLOYEE_BULK_ACTIONS_ENUM.KEYS.CHANGE_ACCESS_UNTIL) {
            this.openChangeAccessUntilTimeModal(this.newAccessUntilTime).then(newAccessUntilTime => {
                this.changeAccessUntilTime(newAccessUntilTime);
            });
        }

        this.bulkAction = null;
    }

    goNext () {
        let state = 'authorized.courses.courses.edit.occurrence.add.schedule';
        if (this.context === 'edit') {
            state = 'authorized.courses.courses.edit.occurrence.edit.schedule';
        }
        this.$state.go(state, {
            id: this.$state.params.id,
            occurrenceId: this.occurrence.id
        });
    }

    changeAccessUntilTime (newAccessUntilTime) {
        const date = this.moment.utc(newAccessUntilTime).local().unix();
        this.occurrence.courseOccurrenceParticipants.forEach((item) => {
            if (this.checkedUserIds.includes(item.userId)) {
                item.accessUntil = date;
            }
        });

        this.beforeSave();
        this.OccurrenceResource.update({ id: this.occurrence.id }, this.occurrence).
        $promise.then(() => {
            this.checkedUserIds = [];
            this.fetch();
        });
    }

    beforeSave () {
        const isDateValid = (date) => {
            const regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
            return String(date).match(regex);
        };

        if (this.occurrence.displayUntil && !isDateValid(this.occurrence.displayUntil)) {
            this.occurrence.displayUntil = this.MomentService.formatTimeStamp(this.occurrence.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
        }

        if (this.occurrence.publishDate && !isDateValid(this.occurrence.publishDate)) {
            this.occurrence.publishDate = this.MomentService.formatTimeStamp(this.occurrence.publishDate, 'YYYY-MM-DD HH:mm:ss', true);
        }

        this.occurrence.languages = this.occurrence.courseOccurrenceLanguages.map(occ => occ.language);

        if (this.occurrence.courseOccurrenceParticipants) {
            this.occurrence.courseOccurrenceParticipants.forEach((item) => {
                if (item.previousPassedTime) {
                    delete item.previousPassedTime;
                }

                if (item.accessUntil && this.moment.unix(item.accessUntil).isValid()) {
                    item.accessUntil = this.MomentService.formatTimeStamp(item.accessUntil, 'YYYY-MM-DD HH:mm:ss', true);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/employee/index.js